import type { ScoreExplanation, ScoreThreshold } from '../../api/types'

export function thresholdRows(thresholds: ScoreThreshold[], appliedBand: string) {
  return thresholds.map((t) => {
    const min = t.min ?? '0.0'
    const range = t.display ?? (t.max === null ? `${min} o más` : `${min} – ${t.max}`)
    return { code: t.code, label: t.label, range: t.display ? t.display : range, applied: t.code === appliedBand }
  })
}

export function explainRounding(raw: string | null, total: string | null, rounding: { places: number; mode: string }): string {
  if (raw === null || total === null) return 'No se puntuó ningún criterio, por lo que no hay suma.'
  const places = `${rounding.places} decimal${rounding.places === 1 ? '' : 'es'}`
  if (raw === total) return `Suma ${raw} (ya con ${places}).`
  return `Suma ${raw} redondeada (mitad hacia arriba) a ${places} = ${total}.`
}

export function coverageText(scored: number, total: number, coverage: string): string {
  return `${scored} de ${total} criterios puntuados (${Math.round(Number(coverage) * 100)}%)`
}

export function sourceDifference(s: Pick<ScoreExplanation, 'source_reported_total' | 'differs_from_source' | 'total'>): { title: string; detail: string } | null {
  if (!s.differs_from_source || s.source_reported_total === null || s.total === null) return null
  const delta = Math.abs(Number(s.total) - Number(s.source_reported_total)).toFixed(1)
  return {
    title: 'Difiere de la hoja de origen',
    detail: `La hoja de origen reportó ${s.source_reported_total}; la plantilla versionada da ${s.total} (una diferencia de ${delta}). Las hojas usan su propia tabla de bandas y valores digitados a mano; aquí se usa el puntaje de la plantilla.`,
  }
}

export function dateFlagNote(flag: string | null | undefined): string | null {
  if (flag === 'date_unknown') return 'La fuente no tiene fecha de inspección; se usó la fecha de importación del informe.'
  if (flag === 'date_suspect') return 'La fecha de inspección parece incorrecta (por ejemplo, una fecha futura dentro de un informe más antiguo). Se conserva en el historial, pero nunca define el estado vigente.'
  return null
}
